import React from 'react'

const AgendaDocsIcon = ({props}) => (
  <svg 
    viewBox="0 0 20 20" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier"> 
      <path d="M17 5.5C17 4.11929 15.8807 3 14.5 3H5.5C4.11929 3 3 4.11929 3 5.5V6H17V5.5Z" fill="currentColor"></path> 
      <path d="M17 9.59971V7H3V14.5C3 15.8807 4.11929 17 5.5 17H9.59971C9.21628 16.2499 9 15.4002 9 14.5C9 11.4624 11.4624 9 14.5 9C15.4002 9 16.2499 9.21628 17 9.59971Z" fill="currentColor"></path> 
      <path 
        d="M10.4175 15.9412C11.2352 15.1544 11.2352 13.8457 10.4175 13.0588L10.2695 12.9165C10.4392
        12.4312 10.6847 11.9834 10.9912 11.5885L11.1901 11.6473C12.2875 11.9715 13.4327 11.3106 13.701 
        10.1981L13.7712 9.90699C14.0085 9.86699 14.252 9.84619 14.5001 9.84619C14.7483 9.84619 14.9918 
        9.86699 15.2291 9.907L15.2993 10.1981C15.5676 11.3106 16.7128 11.9715 17.8102 11.6473L18.0091 
        11.5885C18.3156 11.9834 18.5611 12.4312 18.7308 12.9165L18.5828 13.0588C17.7651 13.8457 17.7651 
        15.1544 18.5828 15.9412L18.7307 16.0836C18.5611 16.5689 18.3156 17.0167 18.0091 17.4116L17.8102 
        17.3528C16.7128 17.0286 15.5676 17.6895 15.2993 18.8019L15.2291 19.0931C14.9918 19.1331 14.7483 
        19.1539 14.5001 19.1539C14.252 19.1539 14.0085 19.1331 13.7712 19.0931L13.701 18.8019C13.4327 
        17.6895 12.2875 17.0286 11.1901 17.3528L10.9912 17.4116C10.6847 17.0167 10.4392 16.5689 10.2695 
        16.0836L10.4175 15.9412ZM13.2735 14.5C13.2735 15.201 13.8227 15.7693 14.5001 15.7693C15.1776 
        15.7693 15.7268 15.201 15.7268 14.5C15.7268 13.7991 15.1776 13.2308 14.5001 13.2308C13.8227 
        13.2308 13.2735 13.7991 13.2735 14.5Z" 
        fill="currentColor"
      >
      </path> 
    </g>
  </svg>


);
export default AgendaDocsIcon